import { defineMessages } from 'react-intl'

export default defineMessages({
  editLabel: {
    id: 'accountSettings.editField.label',
    defaultMessage: 'Edit {optionLabel}',
  },
})
